import { useSelector } from "react-redux";
import { Lessons } from "redux/reducers/lessonsSlice";
import { RootSliceType } from "redux/reducers/rootReducer";

export const useLessonSelector = () => {
  const selectedLesson = useSelector<RootSliceType, Lessons["selectedLesson"]>(
    (state) => state.lessons.selectedLesson
  );
  const loading = useSelector<RootSliceType, Lessons["loading"]>(
    (state) => state.lessons.loading
  );
  const lessonDetails = useSelector<RootSliceType, Lessons["lessonDetails"]>(
    (state) => state.lessons.lessonDetails
  );
  const lessonList = useSelector<RootSliceType, Lessons["lessonList"]>(
    (state) => state.lessons.lessonList
  );
  const lessonCreateLoading = useSelector<RootSliceType, Lessons["lessonCreateLoading"]>(
    (state) => state.lessons.lessonCreateLoading
  );
  const lessonUpdateLoading = useSelector<RootSliceType, Lessons["lessonUpdateLoading"]>(
    (state) => state.lessons.lessonUpdateLoading
  );
  const reservedLessonList = useSelector<
    RootSliceType,
    Lessons["reservedLessonList"]
  >((state) => state.lessons.reservedLessonList);

  return {
    selectedLesson,
    loading,
    lessonDetails,
    lessonList,
    reservedLessonList: reservedLessonList,
    lessonUpdateLoading,
    lessonCreateLoading
  };
};

export default useLessonSelector;
